import { gql } from "@apollo/client";
import { ADDRESS_FIELDS } from "./common";

export const PARTY_FIELDS = gql`
${ADDRESS_FIELDS}
fragment PartyFields on Party {
    id
    name
    type
    email
    address {
        ...AddressFields
    }
  }`
  
  export const USER_FIELDS = gql`
  fragment UserFields on User {
    id
    email
    partyId
    partyRole
    createdAt
    updatedAt
  }`